// @ts-nocheck
import React, { useState, useEffect, useRef } from "react";
import "../../App.css";
import Button from "@mui/material/Button";
import { useHistory, useLocation } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { Dialog } from "@mui/material";
import { toast } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";
import RemoveIcon from "@mui/icons-material/Remove";
import { LinearProgress } from "@mui/material";
import { Check } from "lucide-react";
import ExtractionSuccessModal from "../Models/ExtractionSuccessModal/ExtractionSuccessModal";

import InstaColors, {
  AppCheckbox,
  DeleteButton,
  EditButton,
  fontFamily,
  paddingAndMargin,
  screenHeaderStyle,
  UpperLowerText,
  useSharedValue,
  paginationstyle,
  EXTRACT_NO_SELECTION_MESSAGE,
} from "../Constants/constants";

import {
  ConditionalPagination,
  paginationStyles,
  useDynamicRowsPerPage,
} from "../../utils/paginationUtils";

import "../App.css";
import { handleFileDelete } from "../../services/deleteService";
import DeleteModal from "../Models/Delete/DeleteModal";
import { ParallelProcessModal } from "../Models/Parallel Process Modal/ParallelProcessModal";
import AltVendorIDModal from "./AltVendorIDModal";
import { getUploadTypeDisplayName, columns } from "../../Controller/fileController";
import { uploadExcelForMapping } from "../../services/deloitteService";
import { importFileData } from "../../services/fileDataService";
import { v4 as uuidv4 } from "uuid";
import SearchInput from "../Constants/search_input";
import { formatDate, getAllFilesList } from "../../Utility/utility";
import Loader from "../../Utility/loading";
import { handleLogout } from "../../Utility/utility";

export default function ThirdPartyForms() {
  const history = useHistory();
  const location = useLocation();

  const { selectedRows, handleSelectedRows } = useSharedValue();
  const { notifications, handleNotificationList } = useSharedValue();
  const { selectedRow } = useSharedValue();
  const { successFilename } = useSharedValue();
  const { isSuccessPopup, handleIsSuccessPopup } = useSharedValue();
  const { DataExtractProcess } = useSharedValue();
  const { storeReports } = useSharedValue();
  const { isMenuOpen } = useSharedValue();
  const { defaultBusinessunit, defaultOrganization, defaultUser } = useSharedValue();
  const { numberOfSelectedRows, updateRowNumberOfPages } = useSharedValue();
  const { isRunProcessStarted } = useSharedValue();
  const { isProcessing, processStates, handleProcessingDialogue, metricsList } = useSharedValue();

  const [searchValue, setSearchValue] = useState("");
  const [rows, setRows] = useState([]);
  const [allFiles, setAllFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isCheckedAll, setIsCheckedAll] = useState(false);
  const [temporarySelectedRows, setTemporarySelectedRows] = useState([]);
  const [selectDeletedItem, setSelectDeletedItem] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [userName, setUserName] = useState("");
  const [userId, setUserId] = useState(null);
  const [pendingExtractFileId, setPendingExtractFileId] = useState(null);
  const hasProcessedExtractData = useRef(false);

  // Parallel upload progress
  const [uploadProgress, setUploadProgress] = useState({});
  const [isParallelUploading, setIsParallelUploading] = useState(false);

  // AltVendorID modal
  const [isAltVendorIDModalOpen, setIsAltVendorIDModalOpen] = useState(false);
  const [pendingAltVendorIDRows, setPendingAltVendorIDRows] = useState(null);

  // Pagination
  const [startIndex, setStartIndex] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const { ref: scrollContainerRef, rowsPerPage: dynamicRowsPerPage } = useDynamicRowsPerPage();
  const [endIndex, setEndIndex] = useState(dynamicRowsPerPage);

  // Metrics for progress dialog
  const [totalFiles, setTotalFiles] = useState(null);

  // ── Effects ──────────────────────────────────────────────

  useEffect(() => {
    const userDataJSON = localStorage.getItem("token");
    if (userDataJSON) {
      const userData = JSON.parse(userDataJSON);
      setUserName(userData.firstName + " " + userData.lastName);
      setUserId(userData.userId);
    }
  }, []);

  useEffect(() => {
    setLoading(true);
    getAllFiles();
  }, [defaultBusinessunit, searchValue, defaultOrganization, defaultUser]);

  useEffect(() => {
    if (isRunProcessStarted === false) {
      handleSelectedRows([]);
      setIsCheckedAll(false);
      setTemporarySelectedRows([]);
    }
  }, [isRunProcessStarted]);

  useEffect(() => {
    setCurrentPage(1);
    setStartIndex(0);
    setEndIndex(dynamicRowsPerPage);
  }, [dynamicRowsPerPage]);

  // Handle Extract Data navigation from display_and_edit_file
  useEffect(() => {
    const isExtractDataClicked = location.state?.isExtractDataClicked;
    const fileImportId = location.state?.fileImportId;
    if (
      isExtractDataClicked === true &&
      fileImportId &&
      rows.length > 0 &&
      !hasProcessedExtractData.current
    ) {
      hasProcessedExtractData.current = true;
      const targetRow = rows.find((row) => row.fileImportId === fileImportId);
      if (targetRow) {
        handleSelectedRows([fileImportId]);
        setPendingExtractFileId(fileImportId);
      }
    }
  }, [location.state, rows, handleSelectedRows]);

  useEffect(() => {
    if (!location.state || Object.keys(location.state).length === 0) {
      hasProcessedExtractData.current = false;
    }
  }, [location.state]);

  useEffect(() => {
    if (pendingExtractFileId && selectedRows && selectedRows.includes(pendingExtractFileId)) {
      const row = rows.find((r) => r.fileImportId === pendingExtractFileId);
      if (row && row.uploadType === 13) {
        setPendingAltVendorIDRows(rows);
        setIsAltVendorIDModalOpen(true);
        setPendingExtractFileId(null);
      } else {
        DataExtractProcess(rows);
        setPendingExtractFileId(null);
      }
    }
  }, [pendingExtractFileId, selectedRows]);

  useEffect(() => {
    if (metricsList && metricsList.length > 1) {
      setTotalFiles(metricsList.length);
    }
  }, [metricsList]);

  // ── Data fetching ─────────────────────────────────────────

  const getAllFiles = async () => {
    try {
      const data = await getAllFilesList(
        history,
        defaultOrganization,
        defaultBusinessunit,
        defaultUser,
        1 // Status 1: uploaded, not yet extracted
      );
      setAllFiles(data);
      // Only show uploadType 13 (Third Party / Deloitte Excel) files
      const filteredRows = data.filter(
        (row) =>
          row.isProcessed === false &&
          row.uploadType === 13 &&
          row.fileName.toLowerCase().includes(searchValue.toLowerCase())
      );
      setRows(filteredRows);
    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.message && error.message.includes("401")) {
        handleLogout(history);
      }
    } finally {
      setLoading(false);
    }
  };

  // ── Import Data handler (Excel / uploadType 13) ───────────

  const handleImportData = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    setIsParallelUploading(true);
    try {
      const fileArray = Array.from(files);
      const initialProgress: Record<number, any> = {};
      fileArray.forEach((file, index) => {
        initialProgress[index] = {
          fileName: file.name,
          status: "pending",
          message: "Waiting to start...",
          progress: 0,
        };
      });
      setUploadProgress(initialProgress);

      const { getDefaultBusinessUnit } = await import("../../Utility/utility");
      const firstBusinessUnit = (await getDefaultBusinessUnit()) || "";

      const fileProcessingPromises = fileArray.map(async (file, index) => {
        try {
          if (!file.name.endsWith(".xlsx") && !file.name.endsWith(".xls")) {
            throw new Error("Only Excel files (.xlsx, .xls) are supported");
          }
          const fileId = uuidv4();
          setUploadProgress((prev) => ({
            ...prev,
            [index]: {
              ...prev[index],
              status: "processing",
              message: "Uploading Excel file...",
              progress: 33,
            },
          }));

          const uploadResult = await uploadExcelForMapping(file, fileId);

          setUploadProgress((prev) => ({
            ...prev,
            [index]: {
              ...prev[index],
              status: "processing",
              message: "Storing file data...",
              progress: 66,
            },
          }));

          const newRow = {
            fileImportId: fileId,
            userId,
            fileName: file.name,
            filePath: uploadResult.file_id || fileId,
            prcoessIdentifier: "DELOITTE-EXCEL",
            isProcessed: false,
            businessUnit: firstBusinessUnit,
            uploadedBy: userName,
            uploadedDate: new Date().toISOString(),
            reviewedBy: null,
            reviewedDate: null,
            numberOfFields: null,
            confidenceLevel: null,
            approvedBy: null,
            approvedDate: null,
            emailedTo: null,
            emailedDate: null,
            isInvestment: false,
            isWithholding: true,
            numberOfRows: null,
            numberOfTiers: null,
            uploadType: 13,
            rejectedBy: null,
            rejectedDate: null,
            accuracyPercentage: null,
            rejectionReason: "",
            notes: "Third Party Forms - Ready for mapping",
            totalPages: 1,
            totalForms: 1,
            status: 1,
          };

          await importFileData([newRow]);

          setUploadProgress((prev) => ({
            ...prev,
            [index]: {
              ...prev[index],
              status: "complete",
              message: "Upload complete",
              progress: 100,
            },
          }));

          return { success: true, fileName: file.name };
        } catch (fileError: any) {
          setUploadProgress((prev) => ({
            ...prev,
            [index]: { ...prev[index], status: "failed", message: fileError.message, progress: 0 },
          }));
          return { success: false, fileName: file.name, error: fileError.message };
        }
      });

      const results = await Promise.all(fileProcessingPromises);
      const successfulUploads = results.filter((r) => r.success);
      const failedUploads = results.filter((r) => !r.success);
      const resultNotifications: any[] = [];

      if (successfulUploads.length > 0) {
        resultNotifications.push({
          message: `Successfully uploaded ${successfulUploads.length} file(s). Click 'Extract Data' to process them.`,
          type: "success",
        });
      }
      if (failedUploads.length > 0) {
        const failedFileNames = failedUploads.map((r) => r.fileName).join(", ");
        resultNotifications.push({
          message: `Failed to upload ${failedUploads.length} file(s): ${failedFileNames}`,
          type: "error",
        });
      }
      if (resultNotifications.length > 0) {
        handleNotificationList([
          ...(Array.isArray(notifications) ? notifications : []),
          ...resultNotifications,
        ]);
      }

      await getAllFiles();
      event.target.value = "";
      setIsParallelUploading(false);
      setUploadProgress({});
    } catch (error: any) {
      console.error("Error uploading file:", error);
      handleNotificationList([
        ...(Array.isArray(notifications) ? notifications : []),
        { message: `Error uploading files: ${error.message}`, type: "error" },
      ]);
      setIsParallelUploading(false);
      setUploadProgress({});
      event.target.value = "";
    }
  };

  // ── Extract / AltVendorID ─────────────────────────────────

  const handleRunProcess = async () => {
    if (!selectedRows || selectedRows.length === 0) {
      toast.warning(EXTRACT_NO_SELECTION_MESSAGE);
      return;
    }

    const readyToProcessFiles = rows.filter(
      (row) => row.isProcessed === false && row.businessUnit && row.isWithholding
    );
    if (readyToProcessFiles.length > 0) {
      const hasUploadType13 = selectedRows.some((rowId) => {
        const row = rows.find((r) => r.fileImportId === rowId);
        return row && row.uploadType === 13;
      });
      if (hasUploadType13) {
        setPendingAltVendorIDRows(rows);
        setIsAltVendorIDModalOpen(true);
      } else {
        await DataExtractProcess(rows);
      }
    } else {
      alert(
        "No files are ready to run process. Please ensure files have a client assigned and are recognized as withholding statements."
      );
    }
  };

  const handleAltVendorIDContinue = async (altVendorIDValues: any) => {
    setIsAltVendorIDModalOpen(false);
    const updatedRows = (pendingAltVendorIDRows || []).map((row) => {
      if (row.uploadType === 13 && selectedRows.includes(row.fileImportId)) {
        return {
          ...row,
          altVendorID1: altVendorIDValues.AltVendorID1 || "",
          altVendorID2: altVendorIDValues.AltVendorID2 || "",
          altVendorID3: altVendorIDValues.AltVendorID3 || "",
        };
      }
      return row;
    });
    setRows(updatedRows);
    setPendingAltVendorIDRows(null);
    await DataExtractProcess(updatedRows);
    setTimeout(() => {
      history.replace(location.pathname, {});
    }, 1000);
  };

  // ── Edit / Delete ─────────────────────────────────────────

  const handleEdit = (row: any) => {
    history.push({
      pathname: "/displayAndEditFile",
      state: {
        someValue: row,
        fromPage: "thirdPartyForms",
        returnPath: "/thirdPartyForms",
      },
    });
  };

  const handleDelete = async () => {
    if (!selectDeletedItem) return;
    const rowToDelete = rows.find((row) => row.fileImportId === selectDeletedItem);
    await handleFileDelete({
      fileImportId: selectDeletedItem,
      fileName: rowToDelete?.fileName || "Unknown file",
      rows,
      setIsDeleting,
      getAllFiles,
      setIsPopupOpen,
    });
  };

  // ── Checkbox handlers ─────────────────────────────────────

  const handleColumnCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      const readyToSelectFiles = rows
        .filter((item) => item.isProcessed === false)
        .slice(startIndex, endIndex)
        .filter((row) => row.businessUnit && row.isWithholding);
      if (readyToSelectFiles.length === 0) {
        alert(
          "No files are ready to run process. Please ensure files have a client assigned and upload type is selected."
        );
        return;
      }
      setIsCheckedAll(true);
      const selectedInRange = readyToSelectFiles.map((row) => row.fileImportId);
      handleSelectedRows(selectedInRange);
      setTemporarySelectedRows(selectedInRange);
    } else {
      setIsCheckedAll(false);
      handleSelectedRows([]);
      setTemporarySelectedRows([]);
    }
  };

  const handleRowCheckboxChange = (row: any) => {
    if (!row.businessUnit || !row.uploadType) {
      const missingFields = [];
      if (!row.businessUnit) missingFields.push("business unit");
      if (!row.uploadType) missingFields.push("upload type");
      const userConfirmed = window.confirm(
        `This file is missing required information: ${missingFields.join(" and ")}. Would you like to edit this file?`
      );
      if (userConfirmed) handleEdit(row);
      return;
    }
    if (row.isWithholding === false) {
      alert(
        "This file could not be recognized as a withholding statement. Please try another file."
      );
      return;
    }
    let newRows = [...temporarySelectedRows];
    if (newRows.includes(row.fileImportId)) {
      newRows = newRows.filter((id) => id !== row.fileImportId);
    } else {
      newRows = [...newRows, row.fileImportId];
    }
    setTemporarySelectedRows(newRows);
    handleSelectedRows(newRows);
  };

  // ── Pagination ────────────────────────────────────────────

  const totalPages = Math.ceil(rows.length / dynamicRowsPerPage);

  const handlePageChange = (_event: any, newPage: number) => {
    setCurrentPage(newPage);
    setStartIndex((newPage - 1) * dynamicRowsPerPage);
    setEndIndex((newPage - 1) * dynamicRowsPerPage + dynamicRowsPerPage);
  };

  const calculateProgress = () => {
    if (!processStates || processStates.length === 0) return 0;
    const completedItems = processStates.filter((item: any) => item.status === "complete");
    return totalFiles && totalFiles > 0 ? (completedItems.length / totalFiles) * 100 : 0;
  };

  const progressValue = calculateProgress();

  // ── Render ────────────────────────────────────────────────

  return (
    <>
      <div
        className={`${screenHeaderStyle(isMenuOpen)} file-import-page`}
        style={{ boxShadow: "none" }}
      >
        {/* Deletion overlay */}
        {isDeleting && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0,0,0,0.1)",
              zIndex: 999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                backgroundColor: "white",
                padding: "20px",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                boxShadow: "none",
              }}
            >
              <CircularProgress size={24} style={{ color: InstaColors.primary }} />
              <span style={{ fontFamily, fontSize: "14px" }}>Deleting file...</span>
            </div>
          </div>
        )}

        {/* Top bar: search + buttons */}
        <div
          style={{
            marginTop: paddingAndMargin.headerTopHeight,
            marginBottom: paddingAndMargin.headerBelowHeight,
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
          }}
        >
          <SearchInput
            value={searchValue}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchValue(e.target.value)}
            onClick={() => setSearchValue("")}
          />

          <div style={{ display: "flex", alignItems: "center", marginLeft: "auto" }}>
            <Button variant="contained" component="label" className="review-btn-filled">
              Import Third Party Forms
              <input type="file" hidden multiple accept=".xlsx,.xls" onChange={handleImportData} />
            </Button>
            <Button className="review-btn-filled" onClick={handleRunProcess} variant="contained">
              {selectedRows && selectedRows.length > 0
                ? `Extract Data (${selectedRows.length})`
                : "Extract Data"}
            </Button>
          </div>
        </div>

        {/* Table container */}
        <div
          style={{
            height: "calc(100vh - 220px)",
            display: "flex",
            flexDirection: "column",
            marginLeft: 0,
            marginRight: 0,
          }}
        >
          {/* Fixed header row */}
          <div className="columntitlesRowStyle" style={{ flexShrink: 0 }}>
            <div>
              <AppCheckbox
                header
                checked={isCheckedAll}
                onChange={handleColumnCheckboxChange}
                disabled={rows.length === 0}
              />
            </div>
            {columns.map((column) => (
              <div key={column.field} className="columntitlesStyle">
                <UpperLowerText text={column.headerName} />
              </div>
            ))}
          </div>

          {/* Scrollable rows */}
          {loading ? (
            <div
              style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}
            >
              <Loader />
            </div>
          ) : rows.length === 0 ? (
            <div
              className="no-record"
              style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}
            >
              There are no records available.
            </div>
          ) : (
            <div
              ref={scrollContainerRef}
              style={{ flex: 1, overflowY: "auto", overflowX: "hidden" }}
            >
              {rows
                .filter((item) => item.isProcessed === false)
                .slice(startIndex, endIndex)
                .map((row) => (
                  <div key={row.fileImportId} className="columnRowStyle">
                    <div>
                      <AppCheckbox
                        onChange={() => handleRowCheckboxChange(row)}
                        disabled={selectedRows.includes(row.fileImportId) && isRunProcessStarted}
                        checked={selectedRows.includes(row.fileImportId)}
                      />
                    </div>
                    {columns.map((column) => (
                      <div
                        key={column.field}
                        title={
                          column.headerName === "Uploaded Date"
                            ? formatDate(row[column.field])
                            : column.field === "uploadType"
                              ? getUploadTypeDisplayName(row[column.field])
                              : row[column.field]
                        }
                        className="columnValuesStyle"
                      >
                        {column.field === "processQueue" ? (
                          <div style={{ display: "flex", alignItems: "flex-end" }}>
                            <div style={{ marginRight: "auto" }} />
                            <EditButton onClick={() => handleEdit(row)} />
                            <DeleteButton
                              onClick={() => {
                                setIsPopupOpen(true);
                                setSelectDeletedItem(row.fileImportId);
                              }}
                            />
                          </div>
                        ) : column.field === "processStatus" ? (
                          <div>
                            {row.notes === "UPLOAD_FAILED" ? (
                              <span className="status status-failed">&#x25CF; Upload Failed</span>
                            ) : selectedRows.includes(row.fileImportId) &&
                              selectedRow?.fileImportId === row.fileImportId &&
                              isRunProcessStarted === true &&
                              isProcessing === false ? (
                              <span className="status status-primary">Processing</span>
                            ) : !selectedRows.includes(row.fileImportId) ||
                              isRunProcessStarted === false ? (
                              row.businessUnit && row.isWithholding ? (
                                <span className="status status-success">
                                  &#x25CF; Ready to Process
                                </span>
                              ) : (
                                <span className="status status-danger">Information Required</span>
                              )
                            ) : (
                              isRunProcessStarted && (
                                <span className="status status-warning">Processing</span>
                              )
                            )}
                          </div>
                        ) : column.field === "uploadType" ? (
                          getUploadTypeDisplayName(row[column.field])
                        ) : column.headerName === "Uploaded Date" ? (
                          formatDate(row[column.field])
                        ) : column.field === "fileName" ? (
                          <span
                            style={{
                              color: "#101828",
                              textTransform: "uppercase",
                              fontWeight: 400,
                            }}
                          >
                            {row[column.field]}
                          </span>
                        ) : (
                          row[column.field]
                        )}
                      </div>
                    ))}
                  </div>
                ))}
            </div>
          )}
        </div>

        {/* Processing dialog */}
        <Dialog
          open={isProcessing}
          PaperProps={{
            style: {
              borderRadius: 16,
              padding: "20px",
              backgroundColor: "#ffffff",
              minWidth: 460,
              maxWidth: 500,
              outline: "none",
            },
          }}
        >
          <div
            style={{
              position: "absolute",
              top: 12,
              right: 16,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "8px",
              zIndex: 1,
            }}
          >
            <div
              style={{
                cursor: "pointer",
                width: 24,
                height: 24,
                backgroundColor: "#a1dbf6",
                borderRadius: "6px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={() => handleProcessingDialogue(false)}
            >
              <RemoveIcon style={{ fontSize: 14, color: InstaColors.primary }} />
            </div>
            <div
              style={{
                cursor: "pointer",
                width: 24,
                height: 24,
                backgroundColor: "#a1dbf6",
                borderRadius: "6px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={() => {
                if (window.confirm("Are you sure you want to cancel?")) window.location.reload();
              }}
            >
              <CloseIcon style={{ fontSize: 14, color: InstaColors.primary }} />
            </div>
          </div>

          <div
            style={{
              backgroundColor: "#E9F5FE",
              marginLeft: -20,
              marginRight: -20,
              marginTop: -20,
              paddingLeft: 20,
              paddingRight: 20,
              paddingTop: 20,
              paddingBottom: 0,
              borderRadius: "15px 15px 0 0",
              marginBottom: 20,
            }}
          >
            <div style={{ fontFamily, fontSize: 15, fontWeight: 400, color: "#1a1a1a" }}>
              Processing File:
            </div>
            <div
              style={{
                fontFamily,
                fontSize: 16,
                fontWeight: 400,
                color: InstaColors.primary,
                marginTop: 4,
                height: 25,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {selectedRow?.fileName || "Processing..."}
            </div>
            {totalFiles !== null && totalFiles > 0 && (
              <div style={{ marginTop: 14, marginLeft: -20, marginRight: -20 }}>
                <LinearProgress
                  variant="determinate"
                  value={progressValue}
                  sx={{
                    height: 5,
                    borderRadius: 0,
                    backgroundColor: "#c8e9f8",
                    "& .MuiLinearProgress-bar": { backgroundColor: InstaColors.primary },
                  }}
                />
              </div>
            )}
          </div>

          <div style={{ maxHeight: 300, overflowY: "auto", paddingRight: 4 }}>
            {(processStates || []).map((item: any, index: number) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  padding: "10px 12px",
                  borderRadius: "10px",
                  marginBottom: "8px",
                  backgroundColor:
                    item.status === "complete"
                      ? "#f0f9ff"
                      : item.status === "loading"
                        ? "#fffbf0"
                        : "#fafafa",
                  border: `1px solid ${item.status === "complete" ? "#d0edfb" : item.status === "loading" ? "#fde9a2" : "#ebebeb"}`,
                }}
              >
                <div
                  style={{
                    width: 30,
                    height: 30,
                    borderRadius: "10px",
                    backgroundColor:
                      item.status === "complete"
                        ? "#a1dbf6"
                        : item.status === "loading"
                          ? "#fff8e1"
                          : "#f5f5f5",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  {item.status === "complete" && (
                    <Check style={{ color: InstaColors.primary, fontSize: 12 }} />
                  )}
                  {item.status === "loading" && (
                    <CircularProgress size={20} style={{ color: "#f59e0b" }} />
                  )}
                  {item.status !== "complete" && item.status !== "loading" && (
                    <div
                      style={{
                        width: 18,
                        height: 18,
                        borderRadius: "50%",
                        border: "2px solid #9e9e9e",
                      }}
                    />
                  )}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div
                    style={{
                      fontFamily,
                      fontSize: "13px",
                      fontWeight: 400,
                      color: "#667085",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {item.label}
                  </div>
                  <div
                    style={{
                      fontFamily,
                      fontSize: "11px",
                      color: InstaColors.primary,
                      marginTop: 2,
                    }}
                  >
                    {item.status === "complete"
                      ? "Completed"
                      : item.status === "loading"
                        ? "In Progress"
                        : "Pending"}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Dialog>

        {/* Delete confirmation modal */}
        <DeleteModal
          open={isPopupOpen}
          isDeleting={isDeleting}
          onClose={() => setIsPopupOpen(false)}
          onDelete={handleDelete}
        />

        {/* AltVendorID modal */}
        <AltVendorIDModal
          open={isAltVendorIDModalOpen}
          onClose={() => {
            setIsAltVendorIDModalOpen(false);
            setPendingAltVendorIDRows(null);
          }}
          onContinue={handleAltVendorIDContinue}
        />

        {/* Success modal */}
        <ExtractionSuccessModal
          open={isSuccessPopup}
          successFilename={successFilename}
          onClose={() => {
            handleIsSuccessPopup(false);
            getAllFiles();
          }}
          onGoToExtractionReview={() => {
            history.push({ pathname: "/extractionReview" });
            handleIsSuccessPopup(false);
          }}
        />

        {/* Parallel upload progress modal */}
        <ParallelProcessModal
          open={isParallelUploading}
          uploadProgress={uploadProgress}
          title="File Upload in Progress"
          uploadingMessage="files simultaneously..."
          processingMessage="Files are being processed in parallel for faster upload"
        />
      </div>

      <ConditionalPagination
        itemCount={rows.filter((item) => item.isProcessed === false).length}
        itemsPerPage={dynamicRowsPerPage}
        threshold={dynamicRowsPerPage}
        paginationProps={{
          page: currentPage,
          onChange: handlePageChange,
          style: paginationstyle,
          sx: paginationStyles,
          hidePrevButton: false,
          hideNextButton: false,
          showFirstButton: true,
          showLastButton: true,
        }}
      />
    </>
  );
}
